import AvatarImage from '@pelckmans/elementis/components/avatar/avatar-image';
import Breadcrumbs from '@pelckmans/elementis/components/breadcrumbs';
import { useTranslation } from 'react-i18next';
import { Node } from '../../../../../api/table-of-content';
import { useMaterialLinkBuilder } from '../../../../../hooks/useMaterialLinkBuilder';
import { getDescriptionOfNode } from '../../../../../utils/getNodeDescription';

export default function NodeHierarchyBreadcrumbs({ nodeHierarchy }: { nodeHierarchy: Node[] }) {
  const { buildMaterialTocLink } = useMaterialLinkBuilder();
  const { t } = useTranslation();

  return (
    <>
      {nodeHierarchy.slice(undefined, nodeHierarchy.length - 1).map(node => {
        const title = getDescriptionOfNode(node, t);

        return (
          <Breadcrumbs.Item
            key={node.id}
            avatarImage={node.image ? <AvatarImage name={title} src={node.image} /> : undefined}
            to={buildMaterialTocLink(node.id) || ''}
          >
            {title}
          </Breadcrumbs.Item>
        );
      })}
    </>
  );
}
